export enum CARGO_TYPES {
  coal = "Каменный уголь",
  grain = "Зерно",
  metal = "Металлопрокат",
  petroleum = "Нефтепродукты",
  chemicals = "Химические грузы",
  construction = "Стройматериалы",
  containers = "Контейнеры",
  other = "Другое",
}

export enum WAGON_TYPES {
  freight = "Грузовой",
  tank = "Цистерна",
  refrigerator = "Рефрижератор",
  flatcar = "Платформа",
  hopper = "Хоппер",
  covered = "Крытый",
  open = "Полувагон",
  platform = "Платформа",
}
